import { defineComponent } from 'vue';
import { tradeAreaClient } from '~/lib/client';
import { formatProjectForRequest, numWithDots } from '~/lib/utils';
import Spinner from '../Spinner.vue';
export default defineComponent({
    name: 'EditProject',
    components: { Spinner },
    data() {
        return {
            loadingProjects: false,
            loadingComplete: false,
            savingProject: false,
            projects: [],
            selectedProjectId: 0,
            completeProject: null,
            selectedRoom: null,
        };
    },
    computed: {
        selectedProject() {
            return this.projects.find((p) => p.id === this.selectedProjectId) || null;
        },
    },
    async beforeMount() {
        this.loadingProjects = true;
        this.selectedProjectId = Number(this.$route.query.project);
        const selectedRoom = this.$route.query.room;
        const promeses = [
            this.fetchProjects(),
        ];
        if (this.selectedProjectId) {
            promeses.push(this.fetchCompleteProject());
        }
        await Promise.all(promeses);
        if (this.completeProject !== null) {
            this.selectedRoom = this.completeProject.rooms.find((room) => room.name === selectedRoom) || null;
        }
        this.loadingProjects = false;
    },
    methods: {
        async loadCompleteProject() {
            if (this.selectedProjectId === 0)
                return;
            this.loadingComplete = true;
            this.completeProject = null;
            this.selectedRoom = null;
            await this.fetchCompleteProject();
            this.loadingComplete = false;
        },
        formatPrice(x) {
            return numWithDots(x);
        },
        async fetchProjects() {
            this.projects = await tradeAreaClient.getProjects({ limit: 0 });
        },
        async fetchCompleteProject() {
            this.completeProject = await tradeAreaClient.getProject(this.selectedProjectId);
        },
        async save() {
            if (this.completeProject === null)
                return;
            this.savingProject = true;
            await tradeAreaClient.updateProject(this.selectedProjectId, formatProjectForRequest(this.completeProject));
            this.savingProject = false;
        },
        removeProduct(index) {
            if (this.selectedRoom === null || this.completeProject === null)
                return;
            this.selectedRoom.products.splice(index, 1);
            if (this.selectedRoom.products.length === 0) {
                this.completeProject.rooms.splice(this.completeProject.rooms.indexOf(this.selectedRoom), 1);
                // removing reference to trigger GC
                this.selectedRoom = null;
            }
        },
    },
});
